import { colors } from 'modules/app/styles'
import { Input } from 'reactstrap'
import styled from 'styled-components'
import CardsSprite from 'assets/images/logos/CardsSprite.png'
import { CustomButton } from 'modules/auth/styles'

export const CurrentPlanInfo = styled.div`
  padding: 16px;
  @media (min-width: 576px) {
    padding: 40px;
  }
  display: flex;
  position: relative;
  flex-direction: column;
  .info-label {
    -webkit-text-fill-color: ${colors['text-secondary']};
    color: ${colors['text-secondary']};
    font-weight: 600;
    line-height: 140%;
  }
  .info-value {
    line-height: 150%;
    font-size: 16px;
  }
  .plan-name {
    margin-top: 4px;
    font-weight: 600;
    font-size: 24px;
    line-height: 100%;
  }
  .member-count-slider {
    margin-top: 8px;
    position: relative;
    height: 8px;
    background: ${colors['blue-100']};
    border-radius: 32px;
    .fill {
      position: absolute;
      border-radius: 32px;
      background: ${colors['main-blue']};
      top: 0;
      left: 0;
      bottom: 0;
    }
    .count {
      position: absolute;
      bottom: 0;
      right: 0;
      -webkit-text-fill-color: ${colors['text-secondary']};
      color: ${colors['text-secondary']};
      font-size: 12px;
      font-weight: 600;
      line-height: 18px;
      transform: translateY(100%);
      font-feature-settings: 'lnum';
    }
  }

  .members-list {
    padding: 12px 12px 0 24px;
    max-height: 175px;
    overflow: auto;
    @media (min-width: 576px) {
      max-height: 60vh;
      input {
        width: 315px;
      }
      select {
        width: 120px;
      }
    }
  }

  &.subscribed {
    width: 100%;
    @media (min-width: 576px) {
      width: auto;
    }
  }
`

export const PlanSelector = styled.div`
  border-left: 1px solid #e1e3ed;
  padding: 48px 0 24px;
  @media (min-width: 576px) {
    padding: 48px 48px 24px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  .plan-title {
    margin-top: 24px;
    margin-bottom: 20px;
    font-size: 48px;
    line-height: 48px;
    font-weight: 700;
    font-family: 'PT Serif';
  }
  .plan-amount {
    margin-top: 32px;
    font-family: 'PT Serif';
    font-weight: 700;
    font-size: 24px;
    &.lg {
      font-size: 48px;
    }
    line-height: 34px;
    font-feature-settings: 'liga' off;
    span.amount {
      font-size: 140%;
    }
    span.interval {
      font-family: 'Raleway';
      font-size: 14px;
      font-weight: 400;
    }
    span i {
      font-family: 'Raleway';
      font-size: 10px;
      font-weight: 400;
      padding-left: 5px;
    }
    .strike-through {
      color: ${colors['light-blue-300']};
      position: relative;
      &:after {
        content: '';
        position: absolute;
        left: -4px;
        right: -4px;
        top: 50%;
        // transform: rotate(-45Deg);
        border-bottom: 2px solid ${colors['light-blue-300']};
      }
    }
    .earlybird {
      font-size: 12px;
      font-family: 'Raleway';
      line-height: 1;
      padding: 7px 14px;
      border: 1px dashed #fff;
      background: ${colors['blue-secondary']};
      // color: #fff;
      margin-bottom: 15px;
      border-radius: 20px;
      font-weight: normal;
    }
  }

  .plan-group{
    display: flex;
    gap: 1rem;
  }
  
  ul.plan-specs {
    margin: 0;
    padding: 0;
    li {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 16px;
      svg {
        path {
          fill: ${colors['main-blue']};
        }
        width: 24px;
        height: 24px;
        margin-right: 5px;
      }
    }
  }
  .clients {
    .logos {
      margin-top: 12px;
      img {
        width: auto;
        &:last-child {
          margin-right: 0;
        }
      }
      @media (max-width: 576px) {
        overflow: auto;
        white-space: nowrap;
        width: 100%;
        display: block !important;
      }
    }
    @media (min-width: 576px) {
      min-width: 400px;
    }
  }

  &.checkout {
    padding: 0 0 24px;
    @media (min-width: 576px) {
      padding: 48px 20px 24px;
    }
    .user-count {
      padding: 4px 16px;
      font-size: 16px;
      background-color: ${colors['light-blue-100']};
      border-radius: 40px;
      font-weight: 600;
    }
  }
  .invoice {
    .invoice-heading,
    .invoice-data {
      font-size: 16px;
    }
    &.mobile-cards {
      margin-bottom: 10px;
      box-shadow: 0px 2px 9px 0px #00000014;
      padding: 10px 6px;
      border-radius: 5px;
    }
  }
`

export const PriceLabel = styled.div`
  font-feature-settings: 'lnum';
  cursor: pointer;
  width: 145px;
  &.active {
    color: ${colors['main-blue']};
    font-weight: 600;
  }
`
export const CardInput = styled(Input)`
  font-feature-settings: 'lnum';
  font-weight: 600;
`

export const CardInfo = styled.div`
  border: 1px solid ${colors['light-blue-200']};
  padding: 10px;
  border-radius: 5px;
  .number {
    padding: 5px 10px;
    border-radius: 4px;
    background: ${colors['light-blue-200']};
    display: inline-block;
    margin: 0 3px;
    font-weight: 600;
  }
`
export const CardType = styled.div`
  position: absolute;
  top: 6px;
  height: 21px;
  width: 30px;
  background-image: url(${CardsSprite});
  background-repeat: no-repeat;
  background-size: 100%;
  background-position-x: 0;
  background-position-y: -7px;
  &.visa {
    background-position-y: -154px;
  }
  &.mastercard {
    background-position-y: -253px;
  }
  &.discover {
    background-position-y: -32px;
  }
  &.amex {
    background-position-y: -228px;
  }
  &.jcb {
    background-position-y: -56px;
  }
  &.dinersclub {
    background-position-y: -204px;
  }
  &.laser {
    background-position-y: -277px;
  }
  &.unionpay {
    background-position-y: -130px;
  }
  &.elo {
    background-position-y: -178px;
  }
`
export const ResumePlanButton = styled(CustomButton)`
  width: 178px;
  padding-left: 18px;
  padding-right: 18px;
  svg {
    width: 18px;
    height: 18px;
    path {
      stroke: #fff;
    }
  }
`

export const MoveToFreeButton = styled.a`
  font-family: 'Raleway';
  font-size: 14px;
  line-height: 1.4;
  font-weight: 600;
  padding: 6px 12px;
  color: ${colors.danger};
  border-radius: 40px;
  background: #ffecec;
  &:hover {
    color: ${colors.danger};
    background: #f9d7d7;
  }
`

export const ManagePlanActionButtons = styled.div`
  box-shadow: 0px -2px 9px 0px #00000014;
  @media (min-width: 576px) {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: none;
  }
  padding: 16px 20px;
  border-top: 1px solid ${colors['light-blue-200']};
  background: #fff;
  .invite_message {
    max-height: 0;
    transition: 0.2s;
    overflow: hidden;
    @media (min-width: 576px) {
      textarea {
        margin-top: 16px;
      }
    }
  }
  &.show-invite-message {
    box-shadow: 0px -2px 9px 0px #00000014;
    .invite_message {
      max-height: 120px;
    }
  }
  a {
    font-weight: 600;
  }
  a:hover {
    color: ${colors['main-text']} !important;
  }
  a.invite-message {
    display: flex;
    @media (max-width: 576px) {
      margin: 10px auto;
    }
    .arrow-icon {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: rotate(270deg);
      transition: 0.2s;
      svg {
        width: 20px;
        height: 20px;
      }
      &.open {
        transform: rotate(90deg);
      }
    }
  }
`
export const Divider = styled.div`
  border-left: 1px solid #e1e3ed;
  height: 24px;
`
export const PoweredByStripe = styled.div`
  &.web {
    margin-left: 12px;
    display: none;
  }
  &.mobile {
    display: block;
    margin-bottom: 60px;
  }
  @media (min-width: 576px) {
    &.web {
      display: block;
    }
    &.mobile {
      display: none;
    }
  }
`

export const GracePeriodDiscount = styled.div`
  border: 1px dashed #fff;
  color: #fff;
  background: ${colors['main-blue']};
  padding: 10px 24px;
  text-align: center;
  margin: -16px 0 32px;
  border-radius: 4px;
`

export const KlutchPricingPlans = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  @media (min-width: 992px) {
    flex-direction: row;
  }
  .klutch-pricing-plans {
    display: flex;
    justify-content: center;
    max-width: 1000px;
    margin: 0 auto;
    .klutch-pricing-card {
      border: 1px solid #e3e7f0;
      box-sizing: border-box;
      padding: 55px 40px;
      text-align: center;
      margin: 0 20px;
      .klutch-pricing--header {
        color: #181818;
        margin-bottom: 32px;
        h2 {
          text-transform: capitalize;
          font-family: 'PT Serif';
          font-weight: bold;
          font-size: 28px;
          margin-bottom: 24px;
        }
      }
      .klutch-pricing--price {
        color: #181818;
        margin-bottom: 30px;
        h2 {
          font-family: 'PT Serif';
          font-weight: bold;
          font-size: 48px;
          color: #181818;
        }
        p {
          font-family: 'Raleway';
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
        }
      }
      .klutch-pricing--features {
        ul {
          max-width: 235px;
          margin: 0 auto;
          padding: 0;
          li {
            padding: 8px 0;
            color: ${colors['main-text']};
            font-family: 'Raleway';
            font-size: 16px;
            font-weight: 400;
            text-align: left;
          }
        }
      }
      .klutch-pricing--footer {
        margin-top: 30px;
      }
    }
  }
`

export const BackButton = styled.a`
  display: flex;
  align-items: center;
  margin-right: 25px;
  :hover {
    svg {
      stroke: #0d55ff;
    }
  }
`

export const UnsubscribedCount = styled.div`
  display: flex;
  align-items: center;
  background-color: ${colors['gray-200']};
  min-height: auto;
  border-radius: 40px;
  padding: 4px;
  padding-left: 19px;
  padding-right: 12px;
  .TeamUsers {
    min-height: auto;
    padding: 0;
  }
  .count {
    margin-left: 21px;
    font-size: 16px;
  }
`
